import { observer } from 'mobx-react-lite'

import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'

import { Text } from '@mxenabled/mxui'

import { useGlobalCopyStore } from '../../../../common'
import { type Transaction, Frequency } from '../../../../core'
import SubheaderRow from '../../../../common/components/SubheaderRow'

import { TransactionRow } from '../../../../transactions'

import { fromUnixToDayOfWeekAndDate } from '../../../../core/utils/DateUtil'
import { PaymentSchedule } from '../../PaymentSchedule'

interface AddRecurringTransactionDetailsProps {
  bgcolor?: string
  firstDay: number
  secondDay?: number
  frequency: Frequency
  onFrequencyChange: (frequency: Frequency) => void
  onFirstDayChange: (day: number) => void
  onSecondDayChange: (day: number) => void
  transaction: Transaction
}

export const AddRecurringTransactionDetails = observer(
  ({
    bgcolor = 'background.default',
    firstDay,
    secondDay,
    frequency,
    onFrequencyChange,
    onFirstDayChange,
    onSecondDayChange,
    transaction,
  }: AddRecurringTransactionDetailsProps) => {
    const { recurring: copy } = useGlobalCopyStore()

    return (
      <Stack bgcolor={bgcolor} gap={24} height="100%">
        <Stack>
          <SubheaderRow bgcolor={bgcolor}>
            {fromUnixToDayOfWeekAndDate(transaction.date)}
          </SubheaderRow>
          <TransactionRow component="div" transaction={transaction} />
        </Stack>

        <Box>
          <Text bold={true} sx={{ mx: 24 }} variant="body1">
            {copy.payment_schedule}
          </Text>

          <PaymentSchedule
            firstDay={firstDay}
            frequency={frequency}
            onFirstDayChange={onFirstDayChange}
            onFrequencyChange={onFrequencyChange}
            onSecondDayChange={onSecondDayChange}
            secondDay={secondDay}
          />
        </Box>
      </Stack>
    )
  },
)
